<template>
    <v-container class="container" fluid>
        <v-card>
            <v-toolbar dense dark color="secondary">
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text"
                    >Products by Private Stations</v-toolbar-title
                >
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-data-table
                :headers="headers"
                :items="items"
                :search="search"
                item-key="Id"
                height="600px"
                hide-default-footer
                disable-pagination
                group-by="Station"
                dense
            >
                <template v-slot:top>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="search"
                                label="Search"
                                dense
                                class="float-left"
                                style="margin-top: 0px;padding: 10px;width:40%;"
                                hide-details
                            ></v-text-field>
                            <v-switch
                                label="Collapse"
                                class="float-left"
                                @click="toggleAll()"
                            ></v-switch>
                        </v-col>
                        <v-col cols="1">
                            <v-btn
                                color="secondary"
                                icon
                                class="mt-4"
                                @click="openAddStations()"
                            >
                                <v-icon>mdi-plus-circle-outline</v-icon>
                                Station
                            </v-btn></v-col
                        >
                    </v-row>
                </template>
                <template
                    v-slot:group.header="{ group, headers, toggle, isOpen}"
                >
                    <td :colspan="headers.length" >
                        <v-btn
                            color="secondary"
                            icon
                            class="mr-8"
                            @click="openAddProduct(group)"
                        >
                            <v-icon>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                        {{ group }} {{  }}
                        <v-btn
                            @click="toggle"
                            small
                            icon
                            class="float-right"
                            :ref="group"
                            :data-open="isOpen"
                        >
                            <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                            <v-icon v-else>mdi-chevron-down</v-icon>
                        </v-btn>
                    </td>
                </template>
                <template v-slot:item.Station="{ item }">
                    <td>
                        {{ item.Product }}
                    </td>
                </template>

                <template v-slot:item.SpecificTrailerOnly="{ item }">
                    <td v-if="item.SpecificTrailerOnly">
                        Specific Product
                    </td>
                </template>
            </v-data-table>
        </v-card>
        <addStation v-if="$store.state.privateStations.addStation"></addStation>
        <addProduct v-if="$store.state.privateStations.addProduct" :station="station"></addProduct>
    </v-container>
</template>

<script>
import axios from 'axios';
import addStation from './../Modals/Catalogs/PrivateStations/AddStation.vue';
import addProduct from './../Modals/Catalogs/PrivateStations/AddProduct.vue';
export default {
    components:{
        addStation,
        addProduct
    },
    data: function() {
        return {
            search: null,
            station: null,
            items: [],
            headers: [
                {
                    text: 'Station',
                    value: 'Station',
                    groupable: false,
                    align: 'start',
                    width: '30%'
                },
                {
                    text: 'Product',
                    value: 'Product',
                    align: 'start'
                },
                {
                    text: 'Specific Product',
                    value: 'SpecificTrailerOnly',
                    align: 'start',
                    groupable: false
                }
            ]
        };
    },
    
    watch: {
        '$store.state.privateStations.watch': function() {
            console.log(this.$store.state.privateStations.watch);
            if (this.$store.state.privateStations.watch == true) {
                this.loadProducts();
                this.$store.state.privateStations.watch = false;
            }
        }
    },
    mounted() {
        this.loadProducts();
    },

    methods: {
        openAddProduct(station) {
            console.log(station);
            this.station = station;
            this.$store.state.privateStations.addProduct = true;
        },
        openAddStations() {
            this.$store.state.privateStations.addStation = true;
        },
        toggleAll() {
            Object.keys(this.$refs).forEach(k => {
                //console.log(this.$refs[k])
                this.$refs[k].$el.click();
            });
        },
        loadProducts: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('product-station-priv', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.items = response.data;
                    // this.toggleAll();
                    this.dataLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        }
    }
};
</script>
